import { IndexPath, Select, SelectItem, Text } from "@ui-kitten/components";
import { PlanPackageDetails } from "features/types";
import React, { useState } from "react";
import { View } from "react-native";

interface PlanSelectorProps {
  planPackages: PlanPackageDetails[];
  selectedPlanPackage: PlanPackageDetails | null;
  onChange: (plan: PlanPackageDetails) => void;
  label?: string;
}
const PlanSelector: React.FC<PlanSelectorProps> = ({
  planPackages,
  selectedPlanPackage,
  onChange,
  label,
}) => {
  const [index, setIndex] = useState(new IndexPath(0));

  if (selectedPlanPackage === null) return null;

  if (planPackages.length === 1) {
    return null;
  }

  return (
    <View>
      <Select
        label={label}
        value={selectedPlanPackage.name}
        selectedIndex={index}
        onSelect={(index) => {
          setIndex(index as IndexPath);
          onChange(planPackages[(index as IndexPath).row]);
        }}
        testID="plan-selector"
      >
        {planPackages.map((plan) => (
          <SelectItem
            key={plan.id}
            title={plan.name}
            testID="plan-selector-item"
          />
        ))}
      </Select>
    </View>
  );
};

export default PlanSelector;
